import React, { useContext } from 'react';
import { UnitContext } from '../../../context/UnitContext';
import Translation from '../../../../Shared/components/Translation';
import { ZdsDivider, ZdsSelect, ZdsFormLabel } from '@zig-design-system/ui-components-react';
import SortingService from '../../../services/SortingService';
import { renderToString } from 'react-dom/server';
import ViewLinks from './ViewLinks';
const ViewControl = () => {
    const { state, dispatch } = useContext(UnitContext);
    const sortOptions = state.currentFilterGroup === 'complex' ? SortingService.getAllForComplexes() : SortingService.getAllForUnits();
    return (React.createElement(React.Fragment, null,
        state.currentView !== 'map' && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: `zds-flex zds-justify-content-between zds-items-end sm:zds-items-center zds-margin-top-4` },
                React.createElement("div", null,
                    React.createElement(ZdsFormLabel, { className: "zds-caption zds-self-center zds-bold zds-inline-block zds-margin-right-2" },
                        React.createElement(Translation, { item: "tx_zigrealestate.list.sort" })),
                    React.createElement(ZdsSelect, { onZdsChange: (e) => dispatch({
                            type: 'changeSorting',
                            value: {
                                field: e.target.value.split('_')[0],
                                direction: e.target.value.split('_')[1],
                            },
                        }), name: "sorting", size: "sm", className: "zds-inline-block", value: `${state.sorting.field}_${state.sorting.direction}` }, sortOptions.map((item) => (React.createElement("option", { key: item.field + '_' + item.direction, value: item.field + '_' + item.direction }, renderToString(React.createElement(Translation, { item: item.label, asString: true }))))))),
                React.createElement("div", { className: "zds-flex zds-gap-x-2 md:zds-gap-x-6" },
                    React.createElement(ViewLinks, null))),
            React.createElement(ZdsDivider, { className: "zds-margin-y-4" }))),
        state.currentView === 'map' && React.createElement("div", { className: "zds-padding-top-4 lg:zds-padding-top-0" })));
};
export default ViewControl;
